export var appConfig = {
  showWatchlist: false,
	WelcomeMessage: "Welcome to your Web Portal",
	ClientTitle: "Web Portal",
	showPasswordChangeButtonOnLogin: false,
	showNewsMockup: false,
	showLanguageChangeButtonOnLogin: true,
	loginText:
		'Your Passcode is your PIN + the number displayed on your token. </br> If you experience any problems logging in, please notify us at <a href="mailto:contact@kestrel.ch">contact@kestrel.ch</a>. </br> </br> Votre Passcode est votre PIN + le numéro affiché sur votre token. </br> Si vous rencontrez des problèmes pour vous connecter, veuillez nous en informer à l\'adresse <a href="mailto:contact@kestrel.ch">contact@kestrel.ch</a>.',
	performanceChartSecondSerieName: "",
	portfolioGridSmallScreenColumns: [
		"SecName",
		"Quantity",
		"Currency",
		"CurrentPrice",
		"Valuation",
		"ProfitPerc",
	],
	transactionsGridSmallScreenColumns: [
		"SecName",
		"QuantityWithoutCash",
		"TransAmountRC",
		"TransDate",
		"Description",
	],
	allowedGenericForms: ["All"],
	hidePerformanceChartListColumn: true,
	clientSpecificColumnHidden: ["RatingSnP", "InterestFrequency", "SecNumber"],
	hideSecurityPricesVolume: true,
	sortTransactionsByDefault: true,
	multiSelectWidthSettings: true,
	dropdownWidthSettings: true,
	hideIncludeIgnoredTransactions: true,
	setCarouselTimeout: 10000,
	version: 3.8,
	showThemeSelection: false,
	menuShowRiskProfile: false,
	menuShowMainWindow: false,
	menuShowClientContacts: false,
	menuShowGenericForms: false,
	menuShowDashboard: true,
	menuShowSecurity: true,
	menuShowCrossRates: true,
	menuShowOrdersWindow: false,
	appUserWelcome: false,
	allowTracking: false,
	translationsVersion: 3.8,
	InsaCronAvailable: false,
	showForgotPasswordButtonOnLogin: false,
	availableLocales: ["en-US", "fr-FR"],
	SecMainClass_LIQUIDITY: 10,
	chartColors: [
		"#002143",
		"#1D3F64",
		"#4B6487",
		"#8091AD",
		"#BCC6D7",
		"#B68C65",
		"#D0B396",
		"#EADCCE",
		"#B48A72",
		"#E0BAA3",
	],
	NavigateToReferrerOnLogout: true,
	ActiveIsChecked: true,
	showRegisterButtonOnLogin: false,
	menuShowInsaTrader: false,
	useLegacyIcons: true,
	consolidateAllPositionsVisible: true,
  	separatePositionsByPortfolioVisible: true,
	portalLoginStatsAvaliable: false,
	includeClosedPortfoliosVisible: true,
	initialSettings: {
		enabled: false,
		redirectAfterLogin: "overview",
		dateFrom: "startOfYear",
		dateTo: "today",
		currency: "CHF",
		availableCurrencies: "all",
		partner: "all",
		portfolios: "all",
	},
	customIconGraph: {
		enabled: false,
		fallBackSecurity: "AMZN",
		pageRedirect: "/trader",
	},
	customReport: false,
	OverviewCards: [
		"Portfolio",
		"Charts",
		"Performance",
		"Transactions",
		"CrossRates",
		"News",
	],
};



// WEBPACK FOOTER //
// ./insa-css/insa-clients/Kestrel/insaweb.config.ts